import { connect } from 'react-redux'
import WishlistHeart from './WishlistHeart'
import { addToWishlist, removeFromWishlist } from 'Wishlist/ducks'

const mapStateToProps = ({ wishlistv2: wishlist }) => wishlist

const mapDispatchToProps = dispatch => ({
  toggleWishlistFor: (isInWishlist, sku) => () => isInWishlist
    ? dispatch(removeFromWishlist(sku))
    : dispatch(addToWishlist(sku))
})

const mergeProps = ({ products }, { toggleWishlistFor }, { sku, ...ownProps }) => {
  const isInWishlist = products && products.includes(sku)
  const toggleWishlist = toggleWishlistFor(isInWishlist, sku)

  return { isInWishlist, toggleWishlist, ...ownProps }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(WishlistHeart)



// WEBPACK FOOTER //
// ./src/Wishlist/WishlistHeart/WishlistHeartContainer.js